var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.loading)?_c('production-planning-loading'):[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }